<script setup lang="ts">
import CustomRouterView from "@/layouts/content/CustomRouterView.vue";
import Drawer from "@/layouts/drawer/Drawer.vue";
import DrawerLayout from "@/layouts/drawer/DrawerLayout.vue";
import { DrawerSelection } from "@/layouts/drawer/use-drawer-data";
import { useDrawerStore } from "@/stores";
import { useScreenSize } from "@soft-db/ui";

defineOptions({
	name: "DashboardMainPage",
});

const isIE = window.navigator.userAgent.match(/(MSIE|Trident)/);

const { mdOrLower } = useScreenSize();
const { toggleDrawer } = useDrawerStore();

const router = useRouter();
const route = useRoute();

function changePage(selection: DrawerSelection) {
	router.push({ name: "dashboard-id", params: { id: selection.id }, query: { ...route.query } });

	if (mdOrLower.value) {
		toggleDrawer();
	}
}

const drawerDefaultOpen = computed(() => {
	return route.name === "dashboard-index";
});

const isEditingPublicPage = computed(() => {
	return route.query.publicPage != null;
});
</script>

<template>
	<template v-if="isIE">
		<div class="hero">
			<div class="hero-content flex-col">
				<h1>The Dashboard don't support Internet Explorer.</h1>
				<div>Please use Google Chrome, Firefox, MS Edge, Safari or Opera.</div>
			</div>
		</div>
	</template>
	<template v-else>
		<DrawerLayout :forceOpen="drawerDefaultOpen" :disabled="isEditingPublicPage">
			<template #drawer>
				<Drawer :objects="['site']" @click="changePage" />
			</template>
			<CustomRouterView />
		</DrawerLayout>
	</template>
</template>
